// extracted by mini-css-extract-plugin
module.exports = {"payMain":"cn_payMain__iEfqf","maintenanceNotification":"cn_maintenanceNotification__25_Ti","notificationText":"cn_notificationText__MgpPH"};